module.exports = __webpack_public_path__ + "img/9788960518582.609be51f.jpg";